const $ = require('jquery');

const EXPANDED_CLASS = 'toggle-box--collapsed';
const METHODS = {
    init: function () {
        if (!$(this).closest('.toggle-box').hasClass('toggle-box-inited')) {
            this.on('click', '.toggle-box__title, .toggle-box__toggle', function (e) {
                // Prevent form submit if toggle button is inside a form
                e.preventDefault();
                $(this).closest('.toggle-box').toggleBox('toggle');
            })
            $(this).closest('.toggle-box').addClass('toggle-box-inited');
        }
    },
    toggle: function () {
        var shouldBeCollapsed = !this.toggleBox('isCollapsed');
        this.toggleClass(EXPANDED_CLASS, shouldBeCollapsed);

        return this;
    },
    expand: function () {
        if (this.toggleBox('isCollapsed')) {
            this.toggleBox('toggle');
        }
        return this;
    },
    collapse: function () {
        if (!this.toggleBox('isCollapsed')) {
            this.toggleBox('toggle');
        }
        return this;
    },
    isCollapsed: function () {
        return this.hasClass(EXPANDED_CLASS);
    }
};


$.fn.toggleBox = function (options) {
    if (METHODS[options]) {
        return METHODS[options].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof options === 'object' || !options) {
        // Default to "init"
        return METHODS.init.apply(this, arguments);
    } else {
        $.error('Method ' + options + ' does not exist for "toggleBox"');
    }
};
